import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "main-container",
  ref: "appRoot"
}
const _hoisted_2 = {
  key: 0,
  class: "dialog-bg"
}
const _hoisted_3 = {
  key: 1,
  class: "main-container",
  ref: "appRoot"
}
const _hoisted_4 = {
  key: 0,
  class: "toast-message-wrap"
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<audio muted id=\"audio1\"></audio><audio muted id=\"audio2\"></audio><audio muted id=\"audio3\"></audio><audio muted id=\"audio4\"></audio><audio muted id=\"audio5\"></audio><audio muted id=\"audio6\"></audio>", 6)
const _hoisted_11 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_msg_setting = _resolveComponent("msg-setting")!
  const _component_msg_edit_custom_chip = _resolveComponent("msg-edit-custom-chip")!
  const _component_msg_edit_password = _resolveComponent("msg-edit-password")!
  const _component_msg_bet_history = _resolveComponent("msg-bet-history")!
  const _component_msg_language = _resolveComponent("msg-language")!
  const _component_msg_rule = _resolveComponent("msg-rule")!
  const _component_app_loader = _resolveComponent("app-loader")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-root", { mobile: _ctx.isMobile, 'is-not-ipad': !_ctx.isIpadProDevice }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.initSound($event)))
  }, [
    (_ctx.showMainView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_router_view),
          _createVNode(_Transition, { name: "fadein-out" }, {
            default: _withCtx(() => [
              (_ctx.hasVisibleDialog)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (_ctx.showSetting)
                      ? (_openBlock(), _createBlock(_component_msg_setting, { key: 0 }))
                      : _createCommentVNode("", true),
                    (_ctx.showEditChipMsg)
                      ? (_openBlock(), _createBlock(_component_msg_edit_custom_chip, { key: 1 }))
                      : _createCommentVNode("", true),
                    (_ctx.showEditPassword)
                      ? (_openBlock(), _createBlock(_component_msg_edit_password, { key: 2 }))
                      : _createCommentVNode("", true),
                    (_ctx.showRecordDialogBox)
                      ? (_openBlock(), _createBlock(_component_msg_bet_history, { key: 3 }))
                      : _createCommentVNode("", true),
                    (_ctx.showLanguageDialogBox)
                      ? (_openBlock(), _createBlock(_component_msg_language, { key: 4 }))
                      : _createCommentVNode("", true),
                    (_ctx.showRuleDialogBox)
                      ? (_openBlock(), _createBlock(_component_msg_rule, { key: 5 }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 512))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, null, 512)),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withCtx(() => [
        (_ctx.toastMessageCounter > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("p", null, _toDisplayString(_ctx.toastMessage), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _hoisted_5,
    _createElementVNode("audio", {
      muted: "",
      loop: "",
      id: "soundeffect",
      src: require('@/assets/sounds/musicbg.mp3')
    }, null, 8, _hoisted_11),
    (_ctx.showLoading)
      ? (_openBlock(), _createBlock(_component_app_loader, { key: 2 }))
      : _createCommentVNode("", true)
  ], 2))
}